import {types} from './types'

export const chainsReducer = (state = {}, action) => {
	console.log(action)
	switch (action.type) {
		case types.request:
			return {
				...state,
				loading: true,
			}

		case types.chains:
			return {
				...state,
				loading: false,
				chains: action.payload,
			}

		case types.error:
			return {
				...state,
				loading: false,
				errorMessage: action.payload,
			}

		default:
			return state
	}
}
